import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import DemoForm from "../components/forms/Form";
import FormMini from "../components/forms/FormMini";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Concierge Services - Elm Street</title>
        <meta
          name="description"
          content="Elm Street's Concierge uses industry best practices to help busy real estate professionals convert more leads into appointments. Even better…Concierge's AI technology is backed by a real human who picks up the conversation upon response and runs with it, all with the tone of you &amp; your company."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/concierge_services" />
        <meta property="og:title" content="Concierge Services - Elm Street" />
        <meta
          property="og:description"
          content="Elm Street's Concierge uses industry best practices to help busy real estate professionals convert more leads into appointments. Even better…Concierge's AI technology is backed by a real human who picks up the conversation upon response and runs with it, all with the tone of you &amp; your company."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />



      <ExitModal>
      <div style={{padding:"25px"}}>
                <div style={{textAlign:"center", paddingBottom:"10px"}}> <Typography variant="h4" component="h2" style={{ color: "#333666", textAlign: "center", paddingBottom:"10px" }}>Take The 30-Day <br /><span style={{color:"#f69c26"}}>Marketing Challenge!</span></Typography>
                </div>
                <div style={{textAlign:"center", paddingBottom:"10px"}}>A free downloadable guide with Simple steps to elevate your marketing in less than 1-month.
                </div>
                
                <FormMini buttonText="accept the challenge" successMsg={<div style={{textAlign:"center"}}><Button variant="contained" color="secondary" href="/assets/30daymarketingchallenge.pdf">Download the PDF</Button></div>}
              formName="es2_marketing_challenge" listId="148009" utmOverride="exit_intent" />
                
         </div>
         <div style={{textAlign:"center"}}>
         <Image
                    src="/mcgo.jpg"
                    width="590px"
                    height="242px"
                    alt="30 Day Marketing Challenge FREE Guide"
                   
                  />
                  </div>
     </ExitModal>






      <div
        style={{
          backgroundImage: "url('conciergebg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street Concierge Services"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    <span style={{ color: mainTheme.palette.secondary.main }}>
                      meet your
                      <br />
                      new
                    </span>{" "}
                    personal assistant
                  </Typography>
                  <p>
                    Lead Follow-Up That's
                    <br />
                    Powered by People.
                  </p>
                  <Button variant="contained" color="secondary" href="#form">
                    schedule demo
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={7} sm={12} style={{ paddingBottom: "30px" }}>
                <Typography variant="h4" component="h4">
                  convert
                  <span style={{ color: "#f69c26" }}> more leads</span>
                </Typography>
                <br />
                <span>
                  Elm Street's Concierge uses industry best practices to help busy real estate professionals convert
                  more leads into appointments. Even better…Concierge's AI technology is backed by a real human who
                  picks up the conversation upon response and runs with it, all with the tone of you &amp; your company.
                  Here's how it works...
                  <div style={{ paddingTop: "12px" }}>
                    <strong style={{ color: "#f69c26" }}>1. IMMEDIATE CONTACT:</strong> Concierge instantly contacts
                    your new lead via text message within 1-minute of receipt.
                  </div>
                  <div style={{ paddingTop: "12px" }}>
                    <strong style={{ color: "#f69c26" }}>2. CONSISTENT FOLLOW-UP:</strong> Concierge will attempt to
                    contact unresponsive leads over the course of 1-year using phone calls, text messages, email, and
                    optional voicemails.
                  </div>
                  <div style={{ paddingTop: "12px" }}>
                    <strong style={{ color: "#f69c26" }}>3. HUMAN POWERED:</strong> Responsive leads are instantly
                    matched with a human member of our team and are immediately qualified using customizable scripts via
                    text message and phone calls.
                  </div>
                  <div style={{ paddingTop: "12px" }}>
                    <strong style={{ color: "#f69c26" }}>4. QUALIFIED LEADS DELIVERED:</strong> Qualified leads are
                    instantly delivered to you and your team via live transfer, email, text, and our mobile app. All
                    activity is logged into your CRM.
                  </div>
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" href="#form">
                      schedule demo
                    </Button>
                  </div>
                </span>
              </Grid>
              <Grid item md={5} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image
                    src="/concierge1.png"
                    width="550px"
                    height="733px"
                    alt="Elm Street Concierge Services - Convert More Leads"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('esbg2.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
            paddingBottom: "65px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={5} sm={12}>
                <div>
                  <Image
                    src="/calendar.png"
                    width="1000px"
                    height="1000px"
                    alt="Elm Street Concierge Services - Zero Stress Follow-Up"
                  />
                </div>
              </Grid>
              <Grid item md={7} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                  zero stress
                  <br />
                  <span style={{ color: "#f69c26" }}>follow up</span>
                </Typography>
                <br />
                <span style={{ color: "#ffffff" }}>
                  It takes 10-days of consistent follow-up to connect with an online lead, leading to frustration and
                  wasted time. Elm Street's Concierge takes the stress out of the follow-up, so you can focus on what's
                  important.
                </span>
                <br />
                <br />
                <div style={{ paddingTop: "12px" }}>
                  <Button variant="contained" color="secondary" href="#form">
                    Meet Your Personal Assistant
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  more
                  <span style={{ color: "#f69c26" }}> free time</span>
                </Typography>
                <br />
                <span>
                  Let Concierge do the work for you, so you have more time to focus on your showings, listings, and
                  active clients. We'll let you know as soon as your leads are ready to engage.
                  <br />
                  <br />
                  <strong style={{ color: "#f69c26" }}>UNTIL THEN?</strong>
                  <br />
                  Let Concierge connect and nurture on your behalf.
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" href="#form">
                      learn more
                    </Button>
                  </div>
                </span>
              </Grid>
              <Grid item md={6} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image
                    src="/convo.gif"
                    width="450px"
                    height="645px"
                    unoptimized={true}
                    alt="Elm Street Concierge Services - More Free Time"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('horizonbg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "95px",
            paddingBottom: "65px",
          }}
        >
          <Grid container columnSpacing={16}>
            <Grid item md={4} sm={12} style={{ paddingBottom: "24px" }}>
              <span style={{ color: "#ffffff" }}>
                “Our contact rate for new leads doubled since using Elm Street's Concierge. After trying many companies,
                this is the best, hands-down.”
                <br />
                <strong style={{ color: "#f69c26" }}>Bob H.</strong>
                <br />
                Phoenix, AZ
              </span>
            </Grid>
            <Grid item md={4} sm={12} style={{ paddingBottom: "24px" }}>
              <span style={{ color: "#ffffff" }}>
                “When you're on vacation with family because it's Thanksgiving and your Concierge is hard at work for
                you…well, you gotta love it!”
                <br />
                <strong style={{ color: "#f69c26" }}>Jordan T.</strong>
                <br />
                Denver Metro, CO
              </span>
            </Grid>
            <Grid item md={4} sm={12} style={{ paddingBottom: "24px" }}>
              <span style={{ color: "#ffffff" }}>
                “Elm Street's Concierge is first in line to connect with my leads. The biggest thing is the live person
                responding on my behalf. It's changed my conversion.”
                <br />
                <strong style={{ color: "#f69c26" }}>Kerry D.</strong>
                <br />
                Victoria, BC, Canada
              </span>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container
        maxWidth="lg"
        style={{
          paddingLeft: "20px",
          paddingRight: "20px",
          paddingTop: "95px",
          paddingBottom: "65px",
        }}
      >
        <Grid container columnSpacing={16}>
          <Grid item md={6} sm={12} style={{ paddingBottom: "24px" }}>
            <Typography variant="h3" component="h3">
              Are You Ready
              <br />
              to Meet
              <span style={{ color: "#f69c26" }}>
                {" "}
                YOUR
                <br />
                New Assistant?
              </span>
            </Typography>
            <br />
            <strong>
              Stop chasing leads &amp; let someone
              <br />
              else do the busy work for you.
            </strong>
            <div style={{ paddingTop: "20px" }}>
              <Button variant="contained" color="secondary" href="#form">
                Schedule Demo Today
              </Button>
            </div>
          </Grid>
          <Grid item md={6} sm={12} style={{ paddingBottom: "24px" }}>
            <Typography variant="h5" component="h5">
              <span style={{ color: "#f69c26" }}>POWERFUL</span> Features:
            </Typography>
            <br />
            <strong>Accepts 200+ Lead Sources</strong>
            <br />
            <strong>Instant Notifications</strong> <span style={{ fontSize: "12px" }}>(by email, text or in-app)</span>
            <br />
            <strong>Team-Friendly</strong>
            <br />
            <strong>Smart, Long-Term Follow-Up</strong>
            <br />
            <strong>Real Time Activity Sync with over 14 CRMS</strong>
            <br />
            <span style={{ fontSize: "12px" }}>(Including IXACT &amp; Elevate)</span>
            <br />
            <strong>Mobile App</strong>
            <br />
            <strong>Customizable Outreach</strong>
            <br />
            <strong>Conversion Reports</strong>
            <br />
            <div style={{ paddingTop: "20px" }}>
              <Button variant="contained" color="secondary" href="#form">
                take a tour
              </Button>
            </div>
          </Grid>
        </Grid>
      </Container>

      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{}}>
            <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746", textAlign: "center" }}>
              schedule a demo today
            </Typography>
            <div style={{ paddingBottom: "40px", textAlign: "center" }}>
              <strong style={{ color: "#1d1746" }}>
                It's time to meet your new personal assistant...who LOVES busy work!
              </strong>
            </div>
            <div style={{ padding: "40px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      buttonText="Schedule Demo"
                      successUrl="thankyou"
                      listId="147987"
                      formName="es2_concierge"
                      fieldList={["first_name", "last_name", "email", "phone", "roll"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
